export const makeCommit = ({ id, userId, planItemId, createdAt }) => ({
  id,
  userId,
  planItemId,
  createdAt,
})
